import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path:'/profile',
    name:'Profile',
    component: () => import('../views/Profile.vue')
  },
  {
    path:'/programming',
    name:'Programming',
    component: () => import('../views/Programming.vue')
  },
  {
    path:'/illust',
    name:'Illust',
    component: () => import('../views/Illust.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
